import DesignTokens from '@tableau/design-tokens';
import { DisplayPhoneIcon } from '@tableau/icons/DisplayPhoneIcon';
import { ButtonProps, ButtonType, ButtonWidget, InteractionState } from '@tableau/widgets';
import React from 'react';

import { applyColor } from '~src/style/ColorService';

import { Messages } from '../../../codegen/Localize';
import { PageHeaderStyles } from '../layout/PageHeaderStyles';

function getPreviewButtonContent(displayOnlyIcons: boolean): ((state: InteractionState) => JSX.Element) {
  return (state: InteractionState): JSX.Element => {
    const buttonText = Messages.previewDeviceLayouts();

    const iconStyle = displayOnlyIcons? PageHeaderStyles.iconOnlyButton : PageHeaderStyles.iconForTextButton;

    const backgroundColor = {backgroundColor: (state.hover ? applyColor(DesignTokens.color.component.background.neutral.default.hover, '#ebebeb') : 'transparent')};

    return (
      <div className={PageHeaderStyles.TextButton} style={backgroundColor}>
        <DisplayPhoneIcon size={18} style={iconStyle} />
        {!displayOnlyIcons && buttonText }
      </div>
    );
  };
}

export function DevicePreviewButton(props: DevicePreviewButton.Props):
  React.ReactElement<DevicePreviewButton.Props> {
    const { handleClick, displayOnlyIcons } = props;

    const buttonStyle = {
      display: 'inline-block',
      cursor: 'pointer'
    };

    const testId = 'toggle-device-preview-mode';

    const iconButtonProps: ButtonProps = {
      buttonType: ButtonType.IconOutline,
      getContent: getPreviewButtonContent(displayOnlyIcons),
      testId: testId,
      handleClick: handleClick,
      style: buttonStyle,
      title: Messages.deviceLayoutsTooltip()
    };

    return (
      <ButtonWidget {...iconButtonProps} />
    );
  }

export namespace DevicePreviewButton {
  export interface Props {
    readonly handleClick: () => void;
    readonly displayOnlyIcons: boolean;
  }
}
